module.exports = __webpack_public_path__ + "img/no-cover.c3a8e4e9.png";